import TextField from '@mui/material/TextField'
import React from 'react'
const CommunityTextField = React.memo((props)=>{
  return (
  <TextField {...props}></TextField>
  )
})

export default CommunityTextField
